<template>
  <div id="chooseRuleTemplateList">
    <span>{{project.templateName}}</span>
    &nbsp;
    <i class="icon iconfont icon-shanchu icon-select-rule-tpl" @click="deleteRuleTemplate()"></i>
    &nbsp;
    <i class="icon iconfont icon-modify1 icon-select-rule-tpl" @click="showSelectRuleTemplateDialog()"></i>
    <el-dialog width="898px" :visible.sync="dialogVisible">
      <div class="search-box">
        <span class="search-box-text">选择规则模板</span>
        <eb-search class="search-box-input" @search-click="loadRuleTemplateDataBySearchWord" />
      </div>
      <div class="eb-table">
      <el-table :data="pageData.ruleTemplateList" :stripe="true" @current-change="handleCurrentRowChange">
        <el-table-column label="选中" width="55">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="radioValue" :label="scope.$index">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column property="templateCode" label="模板编号" width="100"></el-table-column>
        <el-table-column property="templateName" label="模板名称" width="160">
          <template slot-scope="scope">
            <span class="templateName" @click="onRuleTemplateNameClick(scope.row)"> {{scope.row.templateName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="userName" label="所属用户" width="120"></el-table-column>
        <el-table-column property="orgName" label="所属机构" width="100"></el-table-column>
        <!-- <el-table-column property="isRemove" label="是否删除" style="display:none;"></el-table-column> -->
        <el-table-column property="publicState" label="公开状态" width="80"></el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            {{scope.row.createTime|dateTimeStandardFormat}}
          </template>
        </el-table-column>
        <el-table-column property="oper" label="操作" width="70">
          <template slot-scope="scope">
            <el-button @click.native.prevent="preview(scope.row)" type="text" size="small">
              预览
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <eb-pagination v-if="pageData.recordsTotal" @current-change="onPageChange" :current-page.sync="currentPage" :page-size="searchParams.length"
        :total="pageData.recordsTotal" />
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">关闭</el-button>
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="selectRuleTemplate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EbSearch from '@/components/common/eb-search';
import EbPagination from '@/components/common/eb-pagination/eb-pagination';
import { listRuleTemplate } from '@/services/rule/rule-template-service';
import { clone } from 'lodash';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    EbSearch,
    EbPagination
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      currentPage: 1,
      initSearchParams: {
        length: 10,
        start: 1
      },
      searchParams: {
        length: 10,
        start: 1
      },
      radioValue: null,
      dialogVisible: false,
      pageData: {
        ruleTemplateList: [],
        recordsTotal: 0
      },
      currentSelectedRow: null
    };
  },
  computed: {},
  watch: {},
  created() {
    this.searchParams = clone(this.initSearchParams);
  },
  methods: {
    // 删除模板，恢复为默认
    deleteRuleTemplate() {
      this.$emit('onDeleteRuleTemplate');
    },
    // 显示选择规则模板弹出层
    showSelectRuleTemplateDialog() {
      this.dialogVisible = true;
      // 重置为表格第一页
      this.currentPage = 1;
      this.resetSearchParams();
    },
    // 重置参数为原始参数
    resetSearchParams() {
      this.searchParams = clone(this.initSearchParams);
      this.loadRuleTemplateData();
    },
    // 搜索操作
    loadRuleTemplateDataBySearchWord(text) {
      this.searchParams.searchWord = text;
      this.loadRuleTemplateData();
    },
    // 当前页改变操作
    onPageChange(pageNum) {
      this.searchParams.start = pageNum;
      this.loadRuleTemplateData();
    },
    // 加载规则模板表格
    async loadRuleTemplateData() {
      try {
        let { data } = await listRuleTemplate(this.searchParams);
        this.pageData.recordsTotal = data.recordsTotal;
        this.pageData.ruleTemplateList = data.data;
      } catch (err) {
        this.$message.error('加载规则模板列表失败');
      }
    },
    // 选中模板操作
    selectRuleTemplate() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择要使用的规则模板');
      } else {
        this.$emit('onSelectRuleTemplate', {
          templateId: this.currentSelectedRow.templateId,
          templateName: this.currentSelectedRow.templateName
        });
      }
    },
    // 点击模板名字操作（直接选中规则模板）
    onRuleTemplateNameClick(currRow) {
      this.currentSelectedRow = currRow;
      this.selectRuleTemplate();
    },
    // 当前选中行改变操作
    handleCurrentRowChange(currRow) {
      this.radioValue = this.pageData.ruleTemplateList.indexOf(currRow);
      this.currentSelectedRow = currRow;
    },
    // 预览
    preview(row) {
      window.open('/v2/rule/template/preview/' + row.templateId);
    }
  }
};
</script>

<style lang="less">
#chooseRuleTemplateList {
  .icon-select-rule-tpl {
    cursor: pointer;
    color: rgb(251, 91, 59);
    font-size: 22px;
    position: relative;
    top: 3px;
  }
  .icon-modify1 {
    font-size: 20px;
  }
  .el-button--text,
  .templateName {
    color: #fb5b3b;
    font-size: 14px;
    cursor: pointer;
  }
  .search-box {
    padding-left: 10px;
    display: flex;
    .search-box-input {
      width: 86%;
      line-height: 16px;
    }
    .search-box-text {
      font-size: 18px;
      color: #333;
      font-weight: 500;
    }
  }
  .el-radio__label {
    display: none;
  }
  .eb-button-group {
    padding: 0;
  }
}
</style>
